import React from "react";
import HierarchyFilter from "components/HierarchyFilter";
import ErrorBoundary from "components/ErrorBoundary";
import ErrorFallback from "components/fallbacks/ErrorFallback";
import { FilterDetails } from "helpers/useGetFilterDetails";
import ReviewFeedFilterConfig from "../../../types/ReviewFeedFilterConfig";
import CommentAnalysisFilterConfig from "../../../types/CommentAnalysisFilterConfig";

const MobileFilterForm: React.FC<{
  filters: string;
  setFilters(s: string): void;
  projectId: string | undefined;
  commentAnalysis?: boolean;
  filterDetails: FilterDetails;
  reviewFeed?: boolean;
  onlyNouns?: boolean;
  noTime?: boolean;
  preFilterSubmitCb?: () => void;
  reviewFeedFilterConfig?: ReviewFeedFilterConfig;
  commentAnalysisFilterConfig?: CommentAnalysisFilterConfig;
  loading?: boolean;
}> = (props) => {
  const { filters, setFilters, projectId: projIdStr, onlyNouns, noTime, preFilterSubmitCb, loading, reviewFeedFilterConfig, commentAnalysisFilterConfig } = props;

  const projectId = projIdStr ? parseInt(projIdStr) : undefined;
  const showFilter = projectId && !isNaN(projectId);

  return (
    <div className="MobileFilterForm">
      <ErrorBoundary fallback={<ErrorFallback narrow />}>
        {showFilter && (
              <HierarchyFilter
                  commentAnalysis={props.commentAnalysis}
                  reviewFeed={props.reviewFeed}
                  filterDetails={props.filterDetails}
                  filters={filters}
                  setFilters={setFilters}
                  projectId={projectId!}
                  onlyNouns={onlyNouns}
                  noTime={noTime}
                  preFilterSubmitCb={preFilterSubmitCb}
                  reviewFeedFilterConfig={reviewFeedFilterConfig}
                  commentAnalysisFilterConfig={commentAnalysisFilterConfig}
                  loading={loading}
              />

        )}
      </ErrorBoundary>
    </div>
  );
};

export default MobileFilterForm;
